// Pages sans jQuery (pages Herbies) : ce bloc ne tourne que si jQuery est là.
window.jQuery && jQuery(function ($) {
  // Native selector highlight (kept harmless; native selector is hidden by CSS)
  $(".product-selector_block").click(function () {
    $(this).closest(".product-selector_outer").find(".product-selector_block").removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });
});

/*
  HEMFORGE-style ATC (Arthur 2026-09-12): add via NATIVE window.fetch so Kaching
  Bundles' fetch patch (__kachingBundlesFetchHandler) intercepts the /cart/add.js
  call and swaps in the selected bundle + discount. jQuery.ajax uses XHR, which
  Kaching does NOT patch, so it must NOT be used for the add.
  Button is type="button" (no native form submit -> no /cart redirect), then we
  open the cart drawer. Vanilla + delegated so it survives section re-render.

  ATC TRACKING FIX (Arthur 2026-09-21): because the add goes through a raw
  window.fetch on a type=button (and Kaching patches fetch), Shopify's automatic
  product_added_to_cart pixel was being bypassed, so NOTHING fired AddToCart
  (verified live: fbq[] + Shopify.analytics.publish[] on a 200 add). We now fire
  AddToCart ourselves on a CONFIRMED add through a Shopify Web Pixels publish only
  (2026-10-16: the direct fbq call was removed, WeTracked already forwards the
  Shopify event to Meta, so fbq + publish counted every add twice).
*/
(function () {
  if (window.__pvAtcInit) return;
  window.__pvAtcInit = true;

  function pvTrackAddToCart(li, fallbackVariantId) {
    try {
      li = li || {};
      var vid = String(li.variant_id || fallbackVariantId || "");
      if (!vid) return;
      var qty = li.quantity || 1;
      var cents = (li.final_line_price != null) ? li.final_line_price : (li.price || 0);
      var value = (cents || 0) / 100;
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
      /* DOUBLE ADDTOCART CORRIGÉ (2026-10-16) : plus de fbq direct ici. WeTracked charge fbq sur la page ET renvoie
         product_added_to_cart à Meta (navigateur + serveur, dédupliqués) ; l'appel fbq en plus comptait chaque ajout deux fois.
         Source unique = l'événement Shopify ci-dessous. value/currency gardés pour référence. */
      void value; void currency;
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
          window.Shopify.analytics.publish("product_added_to_cart", {
            cartLine: { quantity: qty, merchandise: { id: "gid://shopify/ProductVariant/" + vid } }
          });
        }
      } catch (e) {}
    } catch (e) {}
  }

  function resetBtn(btn) {
    if (!btn) return;
    btn.classList.remove("is-loading");
    var stored = btn.getAttribute("data-label-html");
    if (stored != null) btn.innerHTML = stored;
  }

  function openDrawer() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) { window.location.href = "/cart"; return; }
    try { if (typeof drawer._onCartRefresh === "function") drawer._onCartRefresh(); } catch (e) {}
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    setTimeout(function () {
      try {
        drawer.show();
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } catch (e) { window.location.href = "/cart"; }
    }, 300);
  }

  /*
    ATC HARDENING (2026-10-11, Arthur: "de temps en temps Sorry we couldn't add").
    Root causes handled:
    1. A tap before Kaching has loaded (slow phone / weak signal) sent a plain add:
       1 pouch, NO free pouch, or failed outright. We now wait for Kaching
       (window.OpusNoATC + the deal property in the form) and replay the tap so
       Kaching's own click listener tags the deal before our fetch.
    2. Any network/5xx/429/non-JSON failure showed the alert at once, even when
       the add had actually reached the cart. We now check /cart.js for the line
       (Kaching deal id), retry once, and only then show the alert.
    3. Errors were swallowed: the alert now carries a short ref, and the last
       errors are kept in sessionStorage "pv_atc_errors" for diagnosis.
  */
  var pvBusy = false, pvBusySince = 0, pvTries = 0, pvWaited = false, pvReplayFlag = false;

  // Signal for pages that drive this button from their own UI (Herbies pages).
  function pvDone(ok) { try { document.dispatchEvent(new CustomEvent("pv:atc:done", { detail: { ok: ok } })); } catch (e) {} }

  function pvForm() { return document.getElementById("v2-product-form"); }

  function pvDealProp(form) {
    var el = form ? form.querySelector('[name="properties[__kaching_bundles]"]') : null;
    if (!el || !el.value) return null;
    try { return JSON.parse(el.value); } catch (e) { return null; }
  }

  // Ready = Kaching's cart interceptor is running, its deal block has rendered
  // (deal registered + its click listener armed) and the form carries the deal tag.
  function pvKachingReady(form) {
    return window.OpusNoATC === true && !!document.querySelector(".kaching-bundles__bar--selected") && !!pvDealProp(form);
  }

  // Send the form's line properties (the Kaching deal tag) with the add, as a
  // native form submit would: Kaching then merges the free pouch from the tag
  // itself instead of relying on its 2-second fallback window.
  function pvFormProps(form) {
    var props = {}, any = false;
    if (!form) return null;
    var els = form.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < els.length; i++) {
      var m = els[i].name.match(/^properties\[(.+)\]$/);
      if (m && els[i].value !== "") { props[m[1]] = els[i].value; any = true; }
    }
    return any ? props : null;
  }

  // The form and the button can be re-rendered while the page loads: re-read
  // them on every tick and keep the live button in its loading state.
  function pvWaitReady(btn, maxMs) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function tick() {
        if (pvKachingReady(pvForm())) return resolve(true);
        if (Date.now() - t0 >= maxMs) return resolve(false);
        var live = pvLiveBtn(btn);
        if (live && !live.classList.contains("is-loading")) pvSetLoading(live);
        setTimeout(tick, 120);
      })();
    });
  }

  function pvLog(info) {
    try {
      console.error("[PURAVA ATC]", info);
      var k = "pv_atc_errors", arr = JSON.parse(sessionStorage.getItem(k) || "[]");
      info.at = new Date().toISOString();
      arr.push(info);
      sessionStorage.setItem(k, JSON.stringify(arr.slice(-10)));
    } catch (e) {}
  }

  function pvSetLoading(btn) {
    if (btn.getAttribute("data-label-html") == null) btn.setAttribute("data-label-html", btn.innerHTML);
    btn.classList.add("is-loading");
    var loadingLabel = btn.getAttribute("data-loading") || "Adding...";
    var mainLabel = btn.querySelector(".btn-label");
    if (mainLabel) { mainLabel.textContent = loadingLabel; } else { btn.textContent = loadingLabel; }
  }

  function pvPostAdd(variantId, props) {
    var line = { id: variantId, quantity: 1 };
    if (props) line.properties = props;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(line)
    }).then(function (r) {
      return r.text().then(function (txt) {
        var j = null;
        try { j = JSON.parse(txt); } catch (e) {}
        return { ok: r.ok && !!j, status: r.status, body: j, raw: (txt || "").slice(0, 200) };
      });
    });
  }

  // Did this exact add reach the cart? Matches the Kaching deal id written on the
  // line; without a Kaching tag we cannot tell a new line from an old one.
  function pvCommittedLine(dealId, variantId) {
    if (!dealId) return Promise.resolve(null);
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i], tag = it.properties && it.properties.__kaching_bundles;
          if (!tag || String(it.variant_id) !== String(variantId)) continue;
          try { if (JSON.parse(tag).id === dealId) return it; } catch (e) {}
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function pvLineFrom(body, variantId) {
    if (body && body.items && body.items.length) {
      for (var i = 0; i < body.items.length; i++) {
        if (String(body.items[i].variant_id) === String(variantId)) return body.items[i];
      }
      return body.items[0];
    }
    return body;
  }

  function pvSuccess(btn, line, variantId, redirect) {
    pvTrackAddToCart(line, variantId);
    pvBusy = false;
    pvTries = 0;
    pvDone(true);
    if (redirect === "cart") { window.location.href = "/cart"; return; }
    resetBtn(pvLiveBtn(btn));
    openDrawer();
  }

  function pvFail(btn, info) {
    pvBusy = false;
    pvTries = 0;
    pvDone(false);
    resetBtn(pvLiveBtn(btn));
    pvLog(info);
    // Inventory is not tracked, so a 422 "sold out" means the visitor is outside
    // the delivery zone (UK, IE, US, CA, AU, NZ), not that stock ran out.
    var msg = "Sorry, we couldn't add that to your cart. Please try again.";
    if (info.status === 422) {
      msg = /sold out/i.test(info.description || "")
        ? "Sorry, we can't deliver to your location yet. We ship to the UK, Ireland, the US, Canada, Australia and New Zealand."
        : (info.description || msg);
    }
    var ref = " (ref " + (info.status || "net") + " " + ((window.Shopify && Shopify.country) || "?") + ")";
    if (pvDebug()) {
      ref += "\n\n[debug] country=" + ((window.Shopify && Shopify.country) || "?") +
        " kaching=" + info.kaching + " tries=" + info.tries +
        "\n" + (info.description || "") + "\n" + (info.raw || "").slice(0, 160);
    }
    alert(msg + ref);
  }

  // Kaching or the section can re-render the button while we wait: always act on
  // the button that is in the page now, never on a detached one.
  function pvLiveBtn(btn) {
    if (btn && btn.isConnected) return btn;
    var all = document.querySelectorAll(".product-selector_atc");
    for (var i = 0; i < all.length; i++) { if (all[i].offsetParent) return all[i]; }
    return all[0] || btn;
  }

  function pvReplay(btn, delay) {
    setTimeout(function () {
      var live = pvLiveBtn(btn);
      pvSetLoading(live);
      pvReplayFlag = true;
      live.click();
    }, delay || 0);
  }

  function pvDebug() {
    try { return /[?&]pvdebug=1/.test(location.search) || sessionStorage.getItem("pvdebug") === "1"; } catch (e) { return false; }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".product-selector_atc");
    if (!btn) return;
    var replay = pvReplayFlag === true;
    pvReplayFlag = false;
    // Watchdog: never stay locked more than 30 s.
    if (pvBusy && Date.now() - pvBusySince > 30000) { pvBusy = false; pvTries = 0; pvWaited = false; }
    if (!replay && pvBusy) return;
    if (!replay) { pvTries = 0; pvWaited = false; pvBusySince = Date.now(); }

    var form = pvForm();
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var variantId = idInput ? idInput.value : null;
    if (!variantId) return;

    var redirect = btn.getAttribute("data-redirect") || "drawer";
    pvBusy = true;
    pvSetLoading(btn);

    // Tap before Kaching is ready: wait, then replay the tap so Kaching tags the deal.
    if (!pvKachingReady(form) && !pvWaited) {
      pvWaited = true;
      pvWaitReady(btn, 20000).then(function () { pvReplay(btn, 0); });
      return;
    }
    pvWaited = false;

    if (redirect === "checkout") {
      // clear then add so checkout only contains this selection/bundle
      fetch("/cart/clear.js", { method: "POST" })
        .then(function () { return pvPostAdd(variantId, pvFormProps(form)); })
        .then(function (res) {
          if (res && res.ok) pvTrackAddToCart(pvLineFrom(res.body, variantId), variantId);
          window.location.href = "/checkout";
        })
        .catch(function () { window.location.href = "/checkout"; });
      return;
    }

    var deal = pvDealProp(form);
    var dealId = deal && deal.id;
    pvTries = pvTries + 1;

    pvPostAdd(variantId, pvFormProps(form))
      .then(function (res) {
        if (res.ok) return pvSuccess(btn, pvLineFrom(res.body, variantId), variantId, redirect);
        var desc = res.body && (res.body.description || res.body.message);
        // 422 = Shopify refused the add for a real reason (stock, limit): show it, no retry.
        if (res.status === 422) return pvFail(btn, { status: 422, description: desc, raw: res.raw, kaching: !!dealId, tries: pvTries });
        throw { status: res.status, description: desc, raw: res.raw };
      })
      .catch(function (err) {
        var info = (err && err.status !== undefined) ? err : { status: 0, description: String(err && err.message || err) };
        info.kaching = !!dealId;
        info.tries = pvTries;
        return pvCommittedLine(dealId, variantId).then(function (line) {
          if (line) return pvSuccess(btn, line, variantId, redirect);
          if (pvTries < 2) return pvReplay(btn, 900);
          pvFail(btn, info);
        });
      });
  });

  document.addEventListener("dialog:after-hide", function (e) {
    if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === "cart-drawer") {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  });
})();
